
import { defineComponent, PropType, computed } from 'vue'
import { useComputedActiveFilters } from '@bd/components'
import { useI18n } from 'vue-i18n'
import { AdditionalFilter, FilterData } from '@bd/store-modules/types'
import { useAppStore } from '@bd/client/store'
import { useInfiniteScroll } from '@bd/components'

export default defineComponent({
  name: 'DashboardDropdownList',
  emits: ['dropdown-click', 'bottomReach'],
  props: {
    items: {
      type: Object as PropType<FilterData>,
      required: true,
    },
    additionalItems: {
      type: Array as PropType<AdditionalFilter[]>,
      required: false,
    },
  },
  setup(props, { emit }) {
    const i18n = useI18n()
    const store = useAppStore()
    const filtersActive = computed(() =>
      useComputedActiveFilters(store.state.offers?.searchedFilters || {}),
    )

    const selectItem = (item: AdditionalFilter) => {
      const value = item.value || item.cityId || item.districtId
      emit('dropdown-click', value)
    }
    const itemOptions = computed(() => {
      return props.items?.options ? props.items.options : []
    })
    const isActive = (itemValue: string, itemName: string) => {
      return filtersActive.value.some((x) =>
        x.children.find(
          (y) => y.name === itemName && y.value.includes(itemValue),
        ),
      )
    }

    const computedAdditionalItems = computed(() => props.additionalItems)

    const onScroll = useInfiniteScroll(() => {
      emit('bottomReach')
    })

    return {
      ...i18n,
      ...props,
      isActive,
      selectItem,
      itemOptions,
      filtersActive,
      onScroll,
      computedAdditionalItems,
    }
  },
})
